import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';

import { dimensionTypes } from '../../constants/retention';

const { Option } = Select;

const StyledSelect = styled(Select)`
  width: 120px;
`;

const RetentionDimensionSelect = ({ onDimensionTypeChange, dimensionType }) => (
  <StyledSelect
    dropdownMatchSelectWidth
    dropdownStyle={{ width: 'auto' }}
    value={dimensionType || undefined}
    onSelect={(dt) => onDimensionTypeChange(dt)}
    className="ant-select-border-bottom"
    getPopupContainer={(triggerNode) => triggerNode}
    virtual={false}
  >
    <Option value={dimensionTypes.DAILY}>Daily</Option>
    <Option value={dimensionTypes.WEEKLY}>Weekly</Option>
    <Option value={dimensionTypes.MONTHLY}>Monthly</Option>
  </StyledSelect>
);

export default RetentionDimensionSelect;
